import { RULESET as B, DECLARATION as F, COMMENT as M } from "./index.es255.js";
import { from as U, strlen as h, append as A, charat as H, replace as C, indexof as P, abs as y, sizeof as Q, substr as R, trim as V } from "./index.es345.js";
import { dealloc as W, alloc as X, next as S, prev as Y, peek as j, delimit as q, identifier as Z, commenter as _, escaping as x, whitespace as L, node as G, char as N, caret as D } from "./index.es346.js";
function ca(s) {
  return W(J("", null, null, null, [""], s = X(s), 0, [0], s));
}
function J(s, u, t, c, f, E, z, n, m) {
  for (var b = 0, p = 0, r = z, T = 0, k = 0, g = 0, i = 1, v = 1, l = 1, e = 0, d = "", O = f, w = E, o = c, a = d; v; )
    switch (g = e, e = S()) {
      // (
      case 40:
        if (g != 108 && H(a, r - 1) == 58) {
          P(a += C(q(e), "&", "&\f"), "&\f", y(b ? n[b - 1] : 0)) != -1 && (l = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        a += q(e);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        a += L(g);
        break;
      // \
      case 92:
        a += x(D() - 1, 7);
        continue;
      // /
      case 47:
        switch (j()) {
          case 42:
          case 47:
            A($(_(S(), D()), u, t, m), m);
            break;
          default:
            a += "/";
        }
        break;
      // {
      case 123 * i:
        n[b++] = h(a) * l;
      // } ; \0
      case 125 * i:
      case 59:
      case 0:
        switch (e) {
          // \0 }
          case 0:
          case 125:
            v = 0;
          // ;
          case 59 + p:
            l == -1 && (a = C(a, /\f/g, "")), k > 0 && h(a) - r && A(k > 32 ? K(a + ";", c, t, r - 1, m) : K(C(a, " ", "") + ";", c, t, r - 2, m), m);
            break;
          // @ ;
          case 59:
            a += ";";
          // { rule/at-rule
          default:
            if (A(o = I(a, u, t, b, p, f, n, d, O = [], w = [], r, E), E), e === 123)
              if (p === 0)
                J(a, u, o, o, O, E, r, n, w);
              else
                switch (T === 99 && H(a, 3) === 110 ? 100 : T) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    J(s, o, o, c && A(I(s, o, o, 0, 0, f, n, d, f, O = [], r, w), w), f, w, r, n, c ? O : w);
                    break;
                  default:
                    J(a, o, o, o, [""], w, 0, n, w);
                }
        }
        b = p = k = 0, i = l = 1, d = a = "", r = z;
        break;
      // :
      case 58:
        r = 1 + h(a), k = g;
      default:
        if (i < 1) {
          if (e == 123)
            --i;
          else if (e == 125 && i++ == 0 && Y() == 125)
            continue;
        }
        switch (a += U(e), e * i) {
          // &
          case 38:
            l = p > 0 ? 1 : (a += "\f", -1);
            break;
          // ,
          case 44:
            n[b++] = (h(a) - 1) * l, l = 1;
            break;
          // @
          case 64:
            j() === 45 && (a += q(S())), T = j(), p = r = h(d = a += Z(D())), e++;
            break;
          // -
          case 45:
            g === 45 && h(a) == 2 && (i = 0);
        }
    }
  return E;
}
function I(s, u, t, c, f, E, z, n, m, b, p, r) {
  for (var T = f - 1, k = f === 0 ? E : [""], g = Q(k), i = 0, v = 0, l = 0; i < c; ++i)
    for (var e = 0, d = R(s, T + 1, T = y(v = z[i])), O = s; e < g; ++e)
      (O = V(v > 0 ? k[e] + " " + d : C(d, /&\f/g, k[e]))) && (m[l++] = O);
  return G(s, u, t, f === 0 ? B : n, m, b, p, r);
}
function $(s, u, t, c) {
  return G(s, u, t, M, U(N()), R(s, 2, -2), 0, c);
}
function K(s, u, t, c, f) {
  return G(s, u, t, F, R(s, 0, c), R(s, c + 1, -1), c, f);
}
export {
  $ as comment,
  ca as compile,
  K as declaration,
  J as parse,
  I as ruleset
};
//# sourceMappingURL=index.es258.js.map
